import React, { Children, Component } from 'react';

const SingleChildContainer = props => {
  return Children.only(props.children);
};

export default class Overlay extends Component {
  constructor(props) {
    super(props);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.closeOverlay = this.closeOverlay.bind(this);
  }

  componentDidMount() {
    window.addEventListener('keydown', this.handleKeyDown);
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('overlay-open');
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('overlay-open');
  }

  closeOverlay(event, isClick) {
    if (isClick && event.target !== event.currentTarget && !event.target.hasAttribute('data-closes-modal')) {
      return;
    }

    const { onClose } = this.props;
    if (onClose) {
      onClose();
    }
    window.removeEventListener('keydown', this.handleKeyDown);
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('overlay-open');
  }

  handleKeyDown(event) {
    if (event.key === 'Escape') {
      this.closeOverlay(event, false);
    }
  }

  passDownProps(child) {
    const onClick = e => this.closeOverlay(e, true);
    return React.cloneElement(child, { onClick });
  }

  children() {
    const { children } = this.props;
    Children.only(children); // Raises error if more than one child is passed
    return Children.map(children, child => this.passDownProps(child))[0];
  }

  render() {
    return this.children();
  }
}
